import React, { useContext } from 'react';
import Category from '@bit/kards.kards-components.categories-header';
import { ReadContext } from 'src/modules/card/context';
import { ThemeContext } from 'src/modules/card/context/theme';

const CategoryList = () => {
  const {
    cardData,
    setCurrentCategory,
    currentCategory,
  }: any = useContext(ReadContext);
  const {
    theme,
  }: any = useContext(ThemeContext);

  return (
    <Category.component
      theme={theme}
      currentCategory={currentCategory}
      setCurrentCategory={setCurrentCategory}
      data={cardData}
    />
  );
};

export default CategoryList;
